import { render, staticRenderFns } from "./healthInsurance.vue?vue&type=template&id=7bc5be3a&scoped=true"
import script from "./healthInsurance.vue?vue&type=script&lang=ts"
export * from "./healthInsurance.vue?vue&type=script&lang=ts"
import style0 from "./healthInsurance.vue?vue&type=style&index=0&id=7bc5be3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc5be3a",
  null
  
)

export default component.exports